import { Protected } from "@/components/layout/Protected";
import { Box, Grid, Container, Typography, IconButton, SelectChangeEvent, Autocomplete, Button, } from '@mui/material'
import { useState } from "react";
import { Props } from "./InformWorker.type"

import './InformWorker_styles.css'


export const InformWorker: React.FC<Props> = (props: Props): JSX.Element => {

   return (
      <Protected>
         <Container maxWidth='xl' style={{ height: '100vh' }}>
            <Grid container spacing={3} mb={3}>

               <Grid item xs={12}>

                  <Box mb={3} mx={3}>
                     <Typography variant="h6" component="h1" gutterBottom>
                        1Table 'bdsoftne_conta.marcas_22222222' doesn't exist
                     </Typography>
                  </Box>
               </Grid>


            </Grid>

         </Container>
      </Protected>
   );
};

